module.exports = __webpack_public_path__ + "images/icon_play_8a08c1bc9d2060a1aad6f2bbfee32041.svg";